import React from 'react';
import { Users, Globe, CheckCircle, Headphones } from 'lucide-react';
import { motion } from 'framer-motion';

const iconMap = {
  'users': Users,
  'globe': Globe,
  'check-circle': CheckCircle,
  'headphones': Headphones
};

const StatCard = ({ value, label, icon }) => {
  const IconComponent = iconMap[icon] || Users;
  
  return (
    <motion.div
      className="bg-white rounded-xl p-8 shadow-xl text-center"
      whileHover={{ y: -10, scale: 1.05 }}
      transition={{ type: "spring", stiffness: 300 }}
    >
      <IconComponent className="h-12 w-12 mx-auto mb-4 text-avn-purple-600" />
      <div className="text-4xl font-bold text-avn-purple-600 mb-2">{value}</div>
      <p className="text-gray-600">{label}</p>
    </motion.div>
  );
};

export default StatCard;